export const bookingHasCharterFlight = (booking) => {
  if (!booking) return false;
  if (booking.HasCharterFlight === true) return true;
  if (!booking.Passengers) return false;
  for (let pax of booking.Passengers) {
    for (let seg of pax.Segments || []) {
      if (seg.IsCharter === true) return true;
      for (let leg of seg.Legs || []) {
        if (leg.InventoryLeg && leg.InventoryLeg.IsCharter) return true;
      }
    }
  }
  return false;
};

export const formatMoney = (amount) => {

  var formatter = new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
  });

  return formatter.format(amount).replace('\$', '').trim();
};